import {
    BRANCHNAMELISTPARTNER_SUCCESS,
    BRANCHNAMELISTPARTNER_FAILED,
    RESET_BRANCHNAMELISTPARTNER,
    LOADING_BRANCHNAMELISTPARTNER,
    NETWORK_ERROR_BRANCHNAMELISTPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetBranchNameListForPartner = () => {
    return { type: RESET_BRANCHNAMELISTPARTNER };
};

const partnerBranchNameListReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BRANCHNAMELISTPARTNER });
    await partnerServices
        .post("branchnameListpartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerBranchNameListReqsuccess(res.data));
                    break;
                default:
                    dispatch(partnerBranchNameListReqFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BRANCHNAMELISTPARTNER,
                payload: err
            });
        });
};

function partnerBranchNameListReqsuccess(data) {
    return {
        type: BRANCHNAMELISTPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerBranchNameListReqFailed(data) {
    return {
        type: BRANCHNAMELISTPARTNER_FAILED,
        payload: data,
    };
}

export { resetBranchNameListForPartner, partnerBranchNameListReqList }